import dashboard_en from './en/dashboard';
import dashboard_pl from './pl/dashboard';

export default {
    en: {
        dashboard: dashboard_en
    },
    pl: {
        dashboard: dashboard_pl
    }
}
